"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PasswordInput = void 0;

var _tslib = require("tslib");

var _react = _interopRequireDefault(require("react"));

var _Text = _interopRequireDefault(require("../Text"));

var _Box = _interopRequireDefault(require("../../../../Layout/Box"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var PasswordInput = _react.default.forwardRef(function (_a, ref) {
  var _b = _a.variant,
      variant = _b === void 0 ? 'primary' : _b,
      sx = _a.sx,
      passwordProps = (0, _tslib.__rest)(_a, ["variant", "sx"]);
  return _react.default.createElement(_Box.default, (0, _tslib.__assign)({
    as: _Text.default,
    sx: (0, _tslib.__assign)({
      position: 'relative',
      variant: "forms." + variant + ".password"
    }, sx),
    ref: ref
  }, passwordProps));
});

exports.PasswordInput = PasswordInput;